import React, { FC } from 'react';

export const LicenseLabel: FC<{ name: string; className?: string | undefined }> = ({ name, className }) => <span className={className}>{name}</span>;

export const ProductLabel: FC<{ name: string; className?: string | undefined }> = ({ name, className }) => <span className={className}>{name}</span>;
